import React from 'react';
import { Box, Typography } from '@compass/core';
import {
    Chart,
    Series,
    ArgumentAxis,
    ValueAxis,
    Legend,
    Tooltip,
    Label,
    Title
} from 'devextreme-react/chart';
import { SchoolEnrollmentData } from '../types';


interface SchoolEnrollmentChartProps {
    data: SchoolEnrollmentData[];
}

export const SchoolEnrollmentChart: React.FC<SchoolEnrollmentChartProps> = ({ data }) => {
    if (data.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 300,
                    color: 'text.secondary',
                }}
            >
                <Typography variant="body1">No enrollment data available</Typography>
            </Box>
        );
    }


    const getSchoolColor = (schoolType?: string): string => {
        switch (schoolType) {
            case 'Middle':
                return '#3182bd'; 
            case 'High':
                return '#6baed6'; 
            case 'Elementary':
                return '#9ecae1'; 
            default:
                return '#c6dbef'; 
        }
    };

    const chartData = data.map(item => ({
        ...item,
        color: getSchoolColor(item.schoolType),
    }));

    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 400, display: 'flex', flexDirection: 'column' }}>
            <Chart
                dataSource={chartData}
                rotated={true}
            >
                <Series
                    valueField="enrollmentCount"
                    argumentField="schoolName"
                    type="bar"
                    color="#3182bd"
                />

                <ArgumentAxis>
                    <Label wordWrap="none" overlappingBehavior="rotate" />
                </ArgumentAxis>

                <ValueAxis>
                    <Title text="Enrollment Count" />
                </ValueAxis>

                <Legend visible={false} />

                <Tooltip
                    enabled={true}
                    customizeTooltip={(pointInfo: any) => ({
                        text: `${pointInfo.argumentText}: ${pointInfo.valueText} students`,
                    })}
                />
            </Chart>
        </Box>
    );
};